export enum LandscapeTabEnum {
    RESTAURANT = 'restaurant',
    ON_SITE = 'on-site',
}

export const SCOPE_TOTAL_US = 'Total US';
export const SCOPE_MY_TERRITORY = 'My Territory';

export const CUISINES_TITLE = 'US Restaurants: Cuisines';
export const SEGMENTS_TITLE = 'US Restaurants: Segments';
export const READ_ABOUT_IT_TITLE = 'Read About It';
